import React, { useEffect } from 'react'
import { brandCSS } from '../../brand'
import { ITIN_CSS } from './itinerary.css.js'
import { LIGHTBOX_CSS } from '../components/lightbox.css.js'
import Breadcrumb, { BREADCRUMB_CSS } from '../components/Breadcrumb.jsx'
import Reveal from '../components/Reveal'
import ItinHero from './Hero'
import Highlights from './Highlights'
import Days from './Days'
import Experiences from './Experiences'
import CruiseCallout from './CruiseCallout'
import Routemap from '../components/Routemap'
import InclusionExclusion from './InclusionExclusion'
import Notes from './Notes'
import CTASection from '../components/CTASection.jsx'
import BookingSearchForm from '../components/BookingSearchForm.jsx'

function acf(data, key, fallback = null) {
  return data?.acf?.[key] ?? fallback
}

export default function SingleItinerary({ data }) {
  useEffect(() => {
    const root = document.getElementById('app-root')
    if (root) root.style.visibility = 'visible'
  }, [])

  const post = data?.post

  return (
    <>
      <style>{brandCSS + LIGHTBOX_CSS + BREADCRUMB_CSS + ITIN_CSS}</style>
      <div className="si-page">

        <ItinHero
          title={post?.title ?? '3 Days 2 Nights — Le Journey Premier'}
          thumb={post?.thumb}
          duration={acf(data, 'duration')}
          departure={acf(data, 'departure', 'Tuan Chau Marina')}
          cruise={acf(data, 'linked_cruise')}
        />

        <BookingSearchForm />

        <div className="si-main">
          <div className="si-breadcrumb-wrap">
            <Breadcrumb items={data?.post?.breadcrumbs} />
          </div>

          <Reveal variant="fade-up" threshold={0.08}>
            <Highlights items={acf(data, 'highlights')} />
          </Reveal>

          <Reveal variant="fade-up" delay={0.15} threshold={0.06}>
            <Days days={acf(data, 'days')} />
          </Reveal>

          <Reveal variant="fade-up" delay={0.1} threshold={0.08}>
            <CruiseCallout cruise={acf(data, 'linked_cruise')} />
          </Reveal>

          <Reveal variant="fade-up" delay={0.15} threshold={0.06}>
            <Experiences experiences={acf(data, 'experiences')} />
          </Reveal>

          <Reveal variant="fade-in" threshold={0.1}>
            <Routemap
              imageUrl={acf(data, 'routemap_image')}
              sectionClass="si-section"
              imgMaxHeight={520}
              placeholderHeight={320}
            />
          </Reveal>

          <Reveal variant="fade-up" threshold={0.08}>
            <InclusionExclusion
              inclusions={acf(data, 'inclusions')}
              exclusions={acf(data, 'exclusions')}
            />
          </Reveal>

          <Reveal variant="fade-up" delay={0.15} threshold={0.08}>
            <Notes content={acf(data, 'important_notes')} />
          </Reveal>
        </div>

        <CTASection contact={data?.contact} />

      </div>
    </>
  )
}
